import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  const show = false;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Venue | DMBD 2026" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2-opt.jpg"
          title="Venue"
          content="For Participants"
          contentTwo="Venue"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>

          <div className="row row-content align-items-center">
            <div className="col-12">
              <h2>Venue</h2>
              <hr></hr>
              <br></br>
              <h3>The Lakeview Hotel Beijing</h3>
              <p>
              Located in the Zhongguancun, often referred to as &quot;China&apos;s Silicon Valley,&quot; The Lakeview Hotel Beijing (Beida Boya Guoji Huiyi Zhongxin) is situated close to famous Beijing attractions including Yuanming Yuan and the Summer Palace.
On offer in The Lakeview Hotel Beijing are a great variety of rooms. Hot spring waters are piped in directly to rooms from underground spring sources so that guests can enjoy the waters&apos; health benefits in the privacy of their own quarters. The on-site restaurants serve both Chinese and Western cuisines. For recreation, The Lakeview Hotel Beijing guests can enjoy drinks at the lobby bar, make full use of fitness facilities, or enjoy one of the many spa treatments on offer.
              <hr></hr>
                For more information about the hotel, please visit <a href="https://en.thelakeviewbeijing.cn/">https://en.thelakeviewbeijing.cn/</a>
              </p>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/beijing/overview1.jpg" />
                    </td>
                    <td width="50%">
                      <img src="images/beijing/overview2.jpg" />
                    </td>
                  </tr>
                </table>
              </div>
              <hr></hr>
              <h3>Hotel Information</h3>
              <ul>
                <li>
                  Business zone: Peking University / Tsinghua University/College Road
                </li>
                <li>
                  Address: No. 127 Zhongguancun North Street,Haidian District,Beijing,Beijing
                </li>
                <li>
                  Hotel Reserve:+8620-86009099
                </li>
                <li>
                  Overseas reservation:008610-82689999
                </li>

              </ul>
              <hr></hr>

              <h3>Transportation</h3>
              <p className="home-p text-justify">
                Hotel Address : No. 127 Zhongguancun North Street,Haidian District,Beijing,Beijing
              </p>
              <h4>Baidu Map</h4>
              <div className="row">
                <iframe
                  src="https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%8C%97%E5%A4%A7%E5%8D%9A%E9%9B%85%E5%9B%BD%E9%99%85%E9%85%92%E5%BA%97/@12948123.247585764,4838135.336925681,16.14z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%8C%97%E5%A4%A7%E5%8D%9A%E9%9B%85%E5%9B%BD%E9%99%85%E9%85%92%E5%BA%97&c=131&src=0&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA&pn=0&sug=1&l=15&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=17c35f53398694db2cb96d3e&device_ratio=1"
                  width={900}
                  height={600}
                  loading="lazy"
                ></iframe>
              </div>
              <h4>Google Map</h4>
              <div className="row">
                <iframe
                  src="https://www.google.com/maps/place/%E5%8C%97%E4%BA%AC%E5%8C%97%E5%A4%A7%E5%8D%9A%E9%9B%85%E5%9B%BD%E9%99%85%E9%85%92%E5%BA%97/@39.997776,116.3085171,17z/data=!3m1!4b1!4m9!3m8!1s0x37215c28aaba66cd:0x9fc41399caef9658!5m2!4m1!1i2!8m2!3d39.997772!4d116.313388!16s%2Fg%2F1tf18y43?entry=ttu&g_ep=EgoyMDI1MDYwOS4wIKXMDSoASAFQAw%3D%3D"
                  width={900}
                  height={600}
                  loading="lazy"
                ></iframe>
              </div>
              <br></br>
              <hr></hr>

            <h3>Zhongguanyuan Global Village PKU</h3>
              <p>
                The Zhongguanyuan Global Village PKU (Beijing Daxue Zhongguan Xinyuan) is made up of accommodation, catering, conference, teaching, sports and recreational facilities. Located beside Peking University, it is also just steps away from Metro Line 4&apos;s Peking University East Gate Station. Beijing North Railway Station is just 20 minutes&apos; drive away while it will take around 40 minutes to reach the airport. The Lobby Lounge offers a wide selection of food, drinks and snacks while various Chinese and Western restaurants can also be found on-site. With dozens of meeting rooms, a large function room, and professional meeting planning services, this hotel is well equipped to take care of business guests&apos; needs. Sports lovers can hit the gym or choose from a range of activities including swimming, bowling and squash. Less strenuous games such as billiards and ping pong are also available. This Beijing hotel provides free parking.
              <hr></hr>
                For more information about the hotel, please visit <a href="http://en.zhongguanyuanbj.cn/">http://en.zhongguanyuanbj.cn/</a>
              </p>
              <div className="row">
                <table>
                  <tr>
                    <td width="25%">
                      <img src="images/beijing/overview3.jpg" />
                    </td>
                    <td width="50%">
                      <img src="images/beijing/overview4.jpg" />
                    </td>
                  </tr>
                </table>
              </div>
              <hr></hr>
              <h3>Hotel Information</h3>
              <ul>
                {/* <li>
                  Business zone: Peking University / Tsinghua University/College Road
                </li> */}
                <li>
                  Address: No.126 Zhongguancun North Street, Beijing, China
                </li>
                <li>
                  Hotel Reserve:+86 010-62752288
                </li>
              </ul>
              <hr></hr>

              <h3>Transportation</h3>
              <p className="home-p text-justify">
                Hotel Address : No. 127 Zhongguancun North Street,Haidian District,Beijing,Beijing
              </p>
              <h4>Baidu Map</h4>
              <div className="row">
                <iframe
                  src="https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%A4%A7%E5%AD%A6-%E4%B8%AD%E5%85%B3%E6%96%B0%E5%9B%AD/@12949290.204383174,4837607.6256316,17.42z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%A4%A7%E5%AD%A6-%E4%B8%AD%E5%85%B3%E6%96%B0%E5%9B%AD&c=131&src=0&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA&pn=0&sug=1&l=16&b=(12944719.160525057,4836400.561788974;12951527.33464647,4839870.112062387)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=7ed2f9299bf498d5fb2d613b&device_ratio=1"
                  width={900}
                  height={600}
                  loading="lazy"
                ></iframe>
              </div>
              <h4>Google Map</h4>
              <div className="row">
                <iframe
                  src="https://www.google.com/maps/place/%E5%8C%97%E4%BA%AC%E5%A4%A7%E5%AD%A6%E4%B8%AD%E5%85%B3%E6%96%B0%E5%9B%AD/@39.9896941,116.3149101,17z/data=!4m10!3m9!1s0x35f056ac64b7cf1d:0x63d6bea0b79d68c7!5m3!1s2025-06-22!4m1!1i2!8m2!3d39.98969!4d116.317485!16s%2Fg%2F1tfdbmqz?entry=ttu&g_ep=EgoyMDI1MDYwOS4wIKXMDSoASAFQAw%3D%3D"
                  width={900}
                  height={600}
                  loading="lazy"
                ></iframe>
              </div>
              <br></br>
              {/* <h4>Route 1: Airport to hotel</h4>
              You can take bus No. 109 / VIE LIMO to No.109 / VIE LIMO to No.04 / VIE LIMO to No. 08 from Tan Son Nhat International Airport. The journey takes 30-50 minutes.
              <tr></tr><br></br>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/beijing/airporttohotel.png" />
                    </td> */}
                    {/* <td width="50%">
                      <img src="images/sanya/accom11.png" />
                    </td> */}
                  {/* </tr>
                </table>
              </div>
              <br></br>
              <h4>Route 2: Train station to hotel</h4>
              You can take bus No. 65 / No. 07 to No. 04 / No. 07 to No. 109 from Saigon railway station. The journey takes 30-50 minutes. */}

              {/* <tr></tr>     <br></br>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/beijing/railwaystationtohotel.png" />
                    </td>
                    <td width="50%">
                      <img src="images/sanya/accom11.png" />
                    </td>
                  </tr>
                </table>
              </div>

              <hr></hr> */}

              {/* <h3>About Peking University</h3>
              <p className="home-p text-justify">
                Peking University (PKU)(informally known as Beida), is a major research university in
                Beijing, China, and a member of the elite C9 League of Chinese universities. It is
                perennially ranked as one of the top academic institutions in China, Asia, and
                worldwide.The
                first modern national university established in China, it was founded during the late
                Qing
                Dynasty in 1898 as the Imperial University of Peking and was the successor of the
                Guozijian,
                or Imperial College The university&apos;s romanized name, Peking, retains the older
                transliteration of &apot;Beijing&apot; that has been superseded in most other contexts.
                 <div className="text-center">
                  一些图片
                   <img class="img-fluid img-thumbnail" style="width: 90%; height: 600px;"
                                    src="./img/pku_scene.png" /> 
                </div> 
            </p> */}
            </div>



          </div>



          {/* <UnderConstruction/> */}
          {/* <div className="entry-content">
          <p>&nbsp;</p>
          <h5>
          The venue for 2022 International Conference on Swarm Intelligence (ICSI) is to be announced.
          </h5>
          <p>&nbsp;</p>
          <h4>About the venue hotel</h4>
          Blue Horizon Hotel (Qingdao Shilaoren International Exhibition Center
          store) is affiliated to Shandong Blue Horizon Hotel Group, located in
          Laoshan District, Qingdao City, and shilao tourist resort in the
          south. It is an important part of Shandong International Conference
          and Exhibition Center. The rooms are distributed on the 3rd to 9th
          floors, with spacious and bright rooms, equipped with complete
          equipment such as broadband network, satellite TV, international
          direct dial telephone, small bar, electronic safe, etc., and equipped
          with transparent toilet and modern home facilities, showing luxury and
          fashion. It is an ideal choice for you to stay in business and life.
          <p>&nbsp;</p>
          <h4>About the university</h4>
          Ocean University of China (OUC) is a comprehensive university with
          particular strengths in oceanography and fisheries science. We have
          four campuses – Yushan, Fushan, Laoshan and Huangdao, which is
          currently under construction – all of which are united under our motto
          “Ocean embraces all streams; exploring promises reaching far.” OUC was
          one of the first universities approved to confer undergraduate and
          postgraduate degrees by the State Academic Degree Committee and it now
          offers courses in science, engineering, agronomy (fisheries),
          pharmaceutics, economics, management, liberal arts, law, education,
          history, and art. In 2017 it was included in China’s plan of building
          &quot;Double First-Rate&quot; universities, having previously also
          been on the list of &quot;Project 985&quot; universities (a list of
          China’s top 40 universities) and &quot;Project 211&quot; institutions
          (of China’s top 100 universities). It is now the recipient of
          significant national and provincial support and funding, which
          supports its bid to become a world class university.
          <p>&nbsp;</p>
          <h4>Location</h4>
          Address: No. 9-2, Miaoling Road, Laoshan District, Qingdao, China.
          Please refer to the{" "}
          <a href="https://goo.gl/maps/99Co7WDgMxujiNZM8">Google</a> or{" "}
          <a href="https://j.map.baidu.com/c5/tYK">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E9%9D%92%E5%B2%9B%E8%93%9D%E6%B5%B7%E5%A4%A7%E9%A5%AD%E5%BA%97(%E5%B4%82%E5%B1%B1%E5%BA%97)/@13411516,4290391,17z?uid=341c35de82aa8ca7e6073875&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>
          <p>&nbsp;</p>
        </div> */}
        </EmptyTwo>
        {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Venue | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Venue"
          content="For Participants"
          contentTwo="Venue"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Venue;
